export default function NewsletterAction(button) {
  var email = button.closest('.subscription-func').find('.newsletter_email').val();
  if (!email) {
    $('.newsletters-form .newsletter_email').addClass('error');
    return;
  } else {
    $('.newsletters-form .newsletter_email').removeClass('error');
  }

  var eventAction = "Subscribe";
  var url = "/api/Newsletter/Subscribe";
  if (button.is("span")) {
    url = "/api/Newsletter/Unsubscribe";
    eventAction = 'Unsubscribe';
  }
  if (typeof (ga) != 'undefined') {
    ga('send', 'event', 'Newsletter', eventAction, 'User email: ' + email);
  }

  button.prop('disabled', true);

  $.ajax({
    data: JSON.stringify({ Email: email }),
    async: true,
    type: "POST",
    contentType: "application/json",
    url: url,
    beforeSend: function () { button.addClass("show-loader") },
    complete: function () { button.removeClass("show-loader") },
    error: function (jqXHR) {
      if (jqXHR.status === 400) {
        $(".email_error").css("color", "red");
        $(".email_error").text('Felaktig e-postadress').fadeIn('fast');

        $(".newsletter_email").val('');
        button.prop('disabled', false);
      }
    },
    success: function (msg) {
      if (typeof (msg) != 'undefined') {
        if (msg.indexOf("red") == 0) {
          $(".email_error").css("color", "red");
          $(".email_error").text(msg.replaceAll("red;", "")).fadeIn('fast');
        }
        if (msg.indexOf("green") == 0) {
          $(".email_error").css("color", "green");
          $(".email_error").text(msg.replaceAll("green;", "")).fadeIn('fast');
          if (typeof (fbq) != 'undefined') { fbq('track', 'CompleteRegistration'); }
        }

        $(".newsletter_email").val('');
        button.prop('disabled', false);
      }
    }
  });

  return false;
}